var Handlebars = require('/Users/najeeb/Applications/Project/starzhtml5player/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"player-pause-screen\" class=\"player-modal player-modal--resume\">\n    <div class=\"pause container\" style=\"margin: 0 auto;\">\n        <button type=\"button\" class=\"player-modal-button\">\n            <span class=\"icon icon-play icon-resume\" style=\"margin-right: 0;\"></span>\n            <span class=\"icon icon-play icon-resume--hover\" style=\"margin-right: 0; display: none;\"></span>\n        </button>\n    </div>\n</div>\n\n\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/modules/pause_screen/resume_screen.hbs
// module id = 422
// module chunks = 0